import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type CheckCancelFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const CheckCancelFilled = forwardRef<SVGSVGElement, CheckCancelFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-3.333336 -3.333336) scale(1.277778)">
        <path d="M12 3C7.02955 3 3 7.02955 3 12C2.99799 16.9704 7.02754 21 12 21C16.9705 21 21 16.9704 21 12C21 7.02955 16.9705 3 12 3ZM7.98657 9.28811L8.01075 9.26394C8.20819 9.06649 8.5225 9.06649 8.71995 9.26394L9.72733 10.2713L11.9718 8.02686C12.1773 7.82136 12.4997 7.82136 12.7032 8.02686C12.9087 8.22431 12.9087 8.55473 12.7032 8.75218L10.1061 11.3573L10.1001 11.3633L10.0839 11.3794C9.88449 11.5709 9.57018 11.5668 9.37475 11.3714L7.98858 9.99328C7.79114 9.79987 7.79114 9.48355 7.98657 9.28811ZM9.31028 15.6891C9.10477 15.8946 8.78241 15.8946 8.57891 15.6891C8.37341 15.4835 8.37341 15.1612 8.57891 14.9577L15.0363 8.50034C15.2418 8.29483 15.5641 8.29483 15.7676 8.50034C15.9731 8.70584 15.9731 9.03627 15.7676 9.2317L9.31028 15.6891ZM15.9792 15.2095C16.1847 15.415 16.1847 15.7374 15.9792 15.9409C15.7737 16.1464 15.4513 16.1464 15.2478 15.9409L14.6172 15.3103L13.9563 15.9711C13.7508 16.1766 13.4285 16.1766 13.225 15.9711C13.0195 15.7656 13.0195 15.4433 13.225 15.2398L13.8858 14.5789L13.1927 13.8858C12.9872 13.6803 12.9872 13.358 13.1927 13.1545C13.3983 12.949 13.7206 12.949 13.9241 13.1545L14.6172 13.8475L15.278 13.1867C15.4835 12.9812 15.8059 12.9812 16.0094 13.1867C16.2069 13.3842 16.2069 13.7146 16.0094 13.9181L15.3486 14.5789L15.9792 15.2095Z" fill={color} />
      </g>
    </svg>
  ),
);

CheckCancelFilled.displayName = 'CheckCancelFilled';

export default CheckCancelFilled;
